export const SHOW_PLAYER_ERROR = 'SHOW_PLAYER_ERROR';
export const HIDE_PLAYER_ERROR = 'HIDE_PLAYER_ERROR';
